export default __webpack_public_path__ + "static/media/seanals.45b80ac5.png";